import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

/**
 * Register the ripple directive explicitly.
 *
 * vuetify-loader used to auto-import Vuetify components AND directives. Its Vite
 * replacement (unplugin-vue-components + VuetifyResolver) resolves components
 * only — directive resolution is not supported on Vue 2 — so without this the
 * ~9 `v-ripple` usages in our own templates would silently become no-ops.
 *
 * Vuetify's own components import their directives internally and are unaffected.
 */
Vue.directive('ripple', Ripple)

const opts = { theme: { disable: true } }

export default new Vuetify(opts)
